var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.2879 43.8747C56.0533 43.8747 60.7253 39.2027 60.7253 33.4373C60.7253 27.6747 56.0533 23 50.2879 23C44.5226 23 39.8506 27.6747 39.8506 33.4373C39.8506 39.2027 44.5226 43.8747 50.2879 43.8747ZM50.2879 25.6667C54.5706 25.6667 58.0586 29.152 58.0586 33.4373C58.0586 37.7227 54.5706 41.208 50.2879 41.208C46.0053 41.208 42.5173 37.7227 42.5173 33.4373C42.5173 29.152 46.0053 25.6667 50.2879 25.6667Z",
    fill: "#0270B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2907 46.584C37.976 46.584 28 57.9067 28 71.8773V87H34.1307H60.648C59.616 86.2267 58.68 85.336 57.8693 84.3333H36.7973V64.92C36.7973 56.28 42.8533 49.2507 50.2933 49.2507C56.4347 49.2507 61.6213 54.0427 63.248 60.5733C64.0427 60.1893 64.872 59.872 65.736 59.6293C66.0267 59.5467 66.3227 59.464 66.6213 59.4C67.5493 59.1973 68.5067 59.0853 69.4853 59.056C65.608 51.6 58.4747 46.584 50.2907 46.584ZM34.128 64.92V84.3333H30.664V71.8773C30.664 65.928 32.6827 60.5227 35.9493 56.48C34.792 59.008 34.128 61.872 34.128 64.92Z",
    fill: "#0270B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.952 62.333C63.144 62.333 57.624 67.853 57.624 74.6663C57.624 81.4797 63.144 86.9997 69.9574 86.9997C76.7707 86.9997 82.2907 81.4797 82.2907 74.6663C82.2907 67.853 76.7707 62.333 69.952 62.333ZM77.5094 76.6663H71.952V82.2237C71.952 83.3277 71.056 84.2237 69.952 84.2237C68.8427 84.2237 67.952 83.3277 67.952 82.2237V76.6663H62.4C61.296 76.6663 60.4 75.7703 60.4 74.6663C60.4 73.5623 61.296 72.6663 62.4 72.6663H67.952V67.1143C67.952 66.0103 68.848 65.1143 69.952 65.1143C71.056 65.1143 71.952 66.0103 71.952 67.1143V72.6663H77.5094C78.6187 72.6663 79.5147 73.5623 79.5147 74.6663C79.5147 75.7703 78.6187 76.6663 77.5094 76.6663Z",
    fill: "#26BAEC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/AddUser.5963c34d1d4f0e59219805a4ee1737b3.svg";
export { ForwardRef as ReactComponent };